export default {
  'Invalid credentials': 'Credenciais inválidas.',
  'An internal server error occurred': 'Ocorreu um problema!'
}



// WEBPACK FOOTER //
// ./src/utils/custom-messages-pt.js